import { resolveApiUrl } from '../api/config';

export interface AuthStatus {
  authRequired: boolean;
  authConfigured: boolean;
  authDisabled: boolean;
  loginAvailable: boolean;
  reason: string | null;
}

interface AuthStatusResponse {
  auth_required?: boolean;
  auth_configured?: boolean;
  auth_disabled?: boolean;
  login_available?: boolean;
  reason?: string | null;
}

const DEFAULT_AUTH_STATUS: AuthStatus = {
  authRequired: true,
  authConfigured: true,
  authDisabled: false,
  loginAvailable: true,
  reason: null,
};

let cachedAuthStatus: AuthStatus = DEFAULT_AUTH_STATUS;

function normalizeAuthStatus(raw: AuthStatusResponse): AuthStatus {
  return {
    authRequired: raw.auth_required ?? DEFAULT_AUTH_STATUS.authRequired,
    authConfigured: raw.auth_configured ?? DEFAULT_AUTH_STATUS.authConfigured,
    authDisabled: raw.auth_disabled ?? DEFAULT_AUTH_STATUS.authDisabled,
    loginAvailable: raw.login_available ?? DEFAULT_AUTH_STATUS.loginAvailable,
    reason: raw.reason ?? null,
  };
}

export function getAuthStatus(): AuthStatus {
  return cachedAuthStatus;
}

export function setAuthStatus(raw: AuthStatusResponse): AuthStatus {
  cachedAuthStatus = normalizeAuthStatus(raw);
  return cachedAuthStatus;
}

export async function fetchAuthStatus(): Promise<AuthStatus> {
  const response = await fetch(resolveApiUrl('/api/auth/status'), {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: Failed to check auth status`);
  }

  return setAuthStatus(await response.json() as AuthStatusResponse);
}
